import styled from 'styled-components';
import device from '../../mediaQueries';

const FooterLinkWrapper = styled.div`
  align-items: center;
  display: flex;
  font-size: 13px;
  color: #fff;

  ${device.mobile`
    padding: 0 20px;
    height: 34px;
  `}
`;

export default FooterLinkWrapper;
